import type {UndoableState} from '../../vendor/src/features/remotion-editor/editor/state/types';

/** A shared caption source is protected if any of its placed consumers belongs to a locked track. */
export function captionTranslationTargets(document:UndoableState){
 const placed=new Map<string,boolean>();
 const visit=(id:string,locked:boolean,path:Set<string>)=>{
  if(path.has(id)||path.size>=64)throw Error('그룹 연결을 확인한 뒤 번역해 주세요.');
  const item=document.items[id];if(!item)throw Error('번역할 항목의 연결을 확인해 주세요.');
  if(placed.has(id)&&(placed.get(id)||!locked))return;
  placed.set(id,locked);const next=new Set(path);next.add(id);
  if(item.type==='group')for(const child of item.children)visit(child,locked,next);
 };
 for(const track of document.tracks)for(const id of track.items)visit(id,track.locked,new Set());
 const captionAssets=new Set<string>(),protectedAssets=new Set<string>(),editableItems=new Set<string>();
 for(const [id,locked] of placed){
  const item=document.items[id]!;
  if(!locked)editableItems.add(id);
  if(item.type==='captions'){captionAssets.add(item.assetId);if(locked)protectedAssets.add(item.assetId);}
 }
 return {captionAssets,protectedAssets,editableItems};
}
